/*
 * @Author: wufei
 * @Date: 2020-08-11 16:46:11
 * @LastEditTime: 2020-09-18 14:45:21
 * @Description:
 * @FilePath: \mobile-revive\src\api\revive\index.js
 */
import fetch from '@/utils/fetch'

/**
 * 获取饼状图数据
 *
 * @export
 * @returns
 */
export function reviveChart(data) {
    return fetch.request({
        url: '/reviveChart/marketType',
        method: 'post',
        data
    })
}

/**
 * 获取柱状图数据
 *
 * @export
 * @returns
 */
export function lineChart(data) {
    return fetch.request({
        url: '/reviveChart/evalType',
        method: 'post',
        data
    })
}

/**
 * 获取散点图数据
 *
 * @export
 * @returns
 */
export function scatterChart(data) {
    return fetch.request({
        url: '/reviveChart/coundDev',
        method: 'post',
        data
    })
}

/**
 * 偏差列表接口
 *
 * @export
 * @returns
 */
export function findDev(data) {
    return fetch.request({
        url: '/reviveChart/findDev',
        method: 'post',
        data
    })
}

/**
 * 月度复盘-量价走势图表接口
 *
 * @export
 * @returns
 */
export function priceTend(data) {
    return fetch.request({
        url: '/priceTend/list',
        method: 'post',
        data
    })
}
/**
 *new查询复盘form
 *
 * @export
 * @param {*} landId
 * @returns Promise
 */
export function getNewReplayFrom(landId) {
    return fetch.request({
        url: '/revive/getReviveByLandId/' + landId,
        method: 'get'
    })
}
/**
 *获取月度复盘
 *
 * @export
 * @param {*} data
 * @returns
 */
export function getMonthRevive(landId, version) {
    return fetch.request({
        url: `/revive/getMonthRevive/${landId}?version=${version}`,
        method: 'get'
    })
}

/**
 * 获取指定年份有数据的月份信息
 *
 * @export
 * @returns
 */
export function findOpeningTimeMonth(data) {
    return fetch.request({
        url: '/reviveChart/findOpeningTimeMonth',
        method: 'post',
        data
    })
}

/**
 * 获取项目节气数据
 *
 * @export
 * @returns
 */
export function getSolarTermsData(landId) {
    return fetch.request({
        url: `ycJieqi/getInfo/${landId}`,
        method: 'get'
    })
}
